// Custom header functionality
document.addEventListener('DOMContentLoaded', function() {
  // Add scroll event to add shadow on scroll
  const header = document.querySelector('.custom-header');
  
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 0) {
        header.classList.add('custom-header--scrolled');
      } else {
        header.classList.remove('custom-header--scrolled');
      }
    });
  }
});
